import React from 'react';
import styles from './DailySpinWidget.module.scss';

const VipCardSkeleton: React.FC = () => {
  return (
    <>
      <div className={styles.vipProgress}>
        <div className={styles.vipLevel}>
          <div
            className={`${styles.iconCircle} ${styles.skeleton}`}
            style={{ border: 'none', background: 'rgba(255,255,255,0.05)' }}
          ></div>
          <div
            className={`${styles.skeletonText} ${styles.skeleton}`}
            style={{ width: '40px' }}
          ></div>
        </div>

        <div className={styles.progressBarContainer}>
          <div className={`${styles.progressBar} ${styles.skeleton}`}></div>
          <div className={styles.progressText}>
            <div
              className={`${styles.skeletonText} ${styles.skeleton}`}
              style={{ width: '80px', margin: '0 auto' }}
            ></div>
          </div>
        </div>

        <div className={styles.vipLevel}>
          <div
            className={`${styles.iconCircle} ${styles.skeleton}`}
            style={{ border: 'none', background: 'rgba(255,255,255,0.05)' }}
          ></div>
          <div
            className={`${styles.skeletonText} ${styles.skeleton}`}
            style={{ width: '40px' }}
          ></div>
        </div>
      </div>

      <div className={styles.wagerInfo}>
        <div
          className={`${styles.skeletonText} ${styles.skeleton}`}
          style={{ width: '150px', margin: '0 auto' }}
        ></div>
      </div>
    </>
  );
};

export default VipCardSkeleton;
